class HeaderSearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[name="q"]');
    this.clear = this.querySelector("[data-clear]");
    this.submit = this.querySelector('[type="submit"]');

    this.input.addEventListener("input", (e) => this._toggleDirty());

    this.clear.addEventListener("click", () => {
      this._clear();
      this.input.focus();
    });

    this.addEventListener("header-search-form:clear", () => this._clear());
    this.addEventListener("header-search-form:focus", () => this.input.focus());

    this.handleMenuClose = () => {
      this.input.value = "";
    };
  }

  connectedCallback() {
    document.addEventListener("mobile-menu:closed", this.handleMenuClose);
  }

  disconnectedCallback() {
    document.removeEventListener("mobile-menu:closed", this.handleMenuClose);
  }

  _clear() {
    this.input.value = "";
    this._toggleDirty();
  }

  _toggleDirty() {
    this.toggleAttribute("dirty", this.input.value.length);
    if (this.submit) {
      this.submit.disabled = !this.input.value.length;
    }
  }
}

if (!customElements.get("header-search-form")) {
  customElements.define("header-search-form", HeaderSearchForm);
}
